import { useEffect } from "react";

const PreventClickjacking = () => {
  useEffect(() => {
    if (window.self !== window.top) {
      document.body.innerHTML = "<h1>Blocked due to security reasons</h1>";
      window.top.location = window.self.location;
    }
  }, []);

  return null;
};

export default PreventClickjacking;
